import React from "react";
import { IconGridBox, IconGridLayoutOptionsType } from "./IconGridBox";
import { IconGridOptionsType } from "@/types/ModuleOptionsType";
import { Breakpoint } from "@aleksundshantu/aunds-utils-react/layout";
import { IconGridModuleType } from "@/modules/IconGridModule/IconGridModule";
import styles from "./IconGridBox.module.scss";

type IconGridElementType = Exclude<
  IconGridModuleType["icon_grid"]["elements"],
  false
>;

export type IconBoxType = "icon-grid" | "icon-list" | "team";

type IconGridBoxesProps = {
  elements: IconGridElementType;
  infoBoxOptions: IconGridOptionsType;
  extraClass?: string;
  itemWidth: Record<Breakpoint, string>;
  show_cardbox: boolean;
  show_divider: boolean;
  heading_level: number;
  layoutOptions: IconGridLayoutOptionsType;
  boxType?: IconBoxType;
};

export const IconGridBoxes = ({
  elements,
  infoBoxOptions,
  extraClass,
  itemWidth,
  show_cardbox,
  show_divider,
  heading_level,
  layoutOptions,
  boxType = "icon-grid",
}: IconGridBoxesProps) => {
  return (
    <div
      className={`${styles["infoboxes"]} columns m-0 is-multiline is-centered`}
    >
      {elements.map((element, index) => (
        <IconGridBox
          key={index}
          iconGridElement={element}
          extraClass={`${extraClass}`}
          infoBoxOptions={infoBoxOptions}
          itemWidth={itemWidth}
          show_cardbox={show_cardbox}
          show_divider={show_divider}
          heading_level={heading_level}
          layoutOptions={layoutOptions}
          boxType={boxType}
        />
      ))}
    </div>
  );
};
